<template>
  <div class="glossarySubItem">
    <div class="line" v-if="props.itemIndex !== 0"></div>
    <div class="name">
      <Highlight :text="props.name" :patterns="props.keyword" />
    </div>
    <div class="desc">
      <NEllipsis expand-trigger="click" line-clamp="2" :tooltip="false"> {{ desc }} </NEllipsis>
    </div>
  </div>
</template>
<script setup lang="ts">
import { NEllipsis } from 'naive-ui';
import Highlight from '@/components/Highlight';
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: '',
  },
  itemIndex: {
    type: Number,
    default: 0,
  },
  keyword: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped>
.glossarySubItem {
  margin-top: 0.18rem;
  .desc {
    margin-top: 0.08rem;
    font-family: BMWTypeNext, serif;
    font-size: 0.2rem;
    font-weight: 300;
    line-height: 0.271rem;
    text-align: left;
  }
  .name {
    margin-top: 0.18rem;
    font-family: BMWTypeNext, serif;
    font-size: 0.2rem;
    font-weight: 700;
    line-height: 0.271rem;
    text-align: left;
  }
  .line {
    margin-top: 0.02rem;
    width: 100%;
    height: 0.01rem;
    margin-bottom: 0.02rem;
    background-color: #d9dee3;
  }
}
</style>
